import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pos-products',
  templateUrl: './pos-products.component.html',
  styleUrls: ['./pos-products.component.scss'],
})
export class PosProductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
